"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getPackageTrips: ()=>getPackageTrips
});
const index_js_namespaceObject = require("../../constants/index.js");
const getPackageTrips = (trips)=>{
    const { type, isExpressDeal, checkStatusUrl, bundleComponents } = trips || {};
    const firstComponent = bundleComponents[0];
    const lastComponent = bundleComponents[bundleComponents.length - 1];
    const { cityName, stateName, type: componentType } = lastComponent || {};
    let name;
    if (componentType === index_js_namespaceObject.productsType.DRIVE) name = lastComponent.title;
    else if (componentType === index_js_namespaceObject.productsType.STAY) name = `${cityName}${stateName ? `, ${stateName}` : ''}`;
    else if (componentType === index_js_namespaceObject.productsType.FLY) name = lastComponent.header;
    const title = `Trip to ${name}`;
    const travelStartDate = firstComponent.dateHeader.split('-')[0];
    const travelEndDate = lastComponent.dateHeader.split('-')[1];
    const pkgDateHeader = `${travelStartDate}-${travelEndDate}`;
    const pkgType = bundleComponents.reduce((accComp, curComp)=>{
        const { type } = curComp;
        const productName = index_js_namespaceObject.products[type];
        accComp.push(productName);
        return accComp;
    }, []).join(' + ');
    return {
        type,
        isExpressDeal,
        checkStatusUrl,
        title,
        dateHeader: pkgDateHeader,
        pkgType
    };
};
exports.getPackageTrips = __webpack_exports__.getPackageTrips;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getPackageTrips"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
